import Immutable from 'seamless-immutable'
import Api from '../lib/api'

export const SET_USERS = 'SET_USERS'
export const SET_USER_ROLES = 'SET_USER_ROLES'
export const SET_USER = 'SET_USER'
export const UPDATE_USER = 'UPDATE_USER'
export const ADD_USER = 'ADD_USER'
export const DELETE_USER = 'DELETE_USER'

export function loadUsers({page, perPage, organizationId, search, sortDirection, sortBy}={}) {
    return async (dispatch) => {

        let {users,total} = await Api.getUsers({page, perPage, organizationId, search, sortDirection, sortBy})
        dispatch({
            type: SET_USERS,
            users,
            usersCount: total
        })
    }
}
export const loadUserRoles =()=>{
    return async(dispatch)=>{
        let roles = await Api.getUserRoles()
        dispatch({
            type:SET_USER_ROLES,
            roles
        })
    }
}

export const loadUser = ({userId})=>{
    return async (dispatch)=>{
        let user = await Api.getOneuser({userId})
        dispatch({
            type: SET_USER,
            user
        })
    }
}

export const updateUser = ({user, firstName, lastName, email, password, organizationId, role})=>{
    return async (dispatch) =>{
        let update = await Api.updateUser({userId: user.id, firstName, lastName, email, password, organizationId, role})
        if(update){
            dispatch({
                type: UPDATE_USER,
                userId: user.id,
                data: update
            })
        }
        
        return update
    }
}

export const createUser = ({firstName, lastName, email, password, organizationId, role, workspaceId})=>{
    return async (dispatch)=>{
        let user = await Api.createUser({
            firstName, 
            lastName,
            email,
            password,
            organizationId,
            role,
            workspaceId
        })
        if(user){
            dispatch({
                type: ADD_USER,
                user
            })
        }
        return user
        
    }
}

export const deleteUser = ({user})=>{
    return async (dispatch)=>{
        let removed = await Api.deleteUser({userId: user.id})
        if(removed){
            dispatch({
                type: DELETE_USER,
                user
            })
        }
    }
}



const updateUserInState = ({state, action})=>{
    const {userId, data} = action
    let users = state.users.map((user)=>{
        if(user.id === userId){
            return user.merge(data)
        }
        return user
    })
    state = state.set('users', users)
    if(state.user && state.user.id === userId){
        state = state.set('user', state.user.merge(data))
    }
    return state
}


const initialState = Immutable({users: []})

export const reducer = (state = initialState, action)=>{

    switch (action.type) {

    case SET_USERS:
        return state.set('users', action.users).set('usersCount', action.usersCount)
    case SET_USER_ROLES:
        return state.set('roles', action.roles)
    case SET_USER:
        return state.set('user', action.user)
    case DELETE_USER:
        return state.set('users', state.users.filter((user)=>{
            return user.id !== action.user.id
        }))
    case UPDATE_USER:
        return updateUserInState({state, action})
    case ADD_USER:
        return state.set('users', [action.user].concat(state.users))
    default:
        return state
    }

}



// WEBPACK FOOTER //
// ./src/actions/users.js